import { render } from "./foodModel.vue?vue&type=template&id=38c5d00e"
import script from "./foodModel.vue?vue&type=script&lang=js"
export * from "./foodModel.vue?vue&type=script&lang=js"

import "./foodModel.vue?vue&type=style&index=0&id=38c5d00e&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__